import React, { useContext, useCallback } from 'react';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { FORM_STATES, FORM_EVENTS, useFormService } from '@bingads-webui-react/form';
import { Button } from '@fluentui/react-components';

import { useFooterStyles } from '../styles/footer-styles';

export function withFooter(WrappedComponent, showBudgetSuggestion?) {
  const HoC = (props) => {
    const i18n = useContext(I18nContext) as any;
    const styles = useFooterStyles();
    const { state, send } = useFormService();
    const isLoading = state.matches(FORM_STATES.LOADING);

    const onSave = useCallback(() => send(FORM_EVENTS.SAVE), [send]);
    const onCancel = useCallback(() => send(FORM_EVENTS.CANCEL), [send]);
    return (
      <>
        <WrappedComponent
          {...props as any}
        />
        {!showBudgetSuggestion &&
        <div className={styles.container}>
          <Button disabled={isLoading} className={classNames('save-btn', styles.saveButton)} onClick={onSave} appearance="primary">{i18n.getString(_TL_('Save'))}</Button>
          <Button disabled={isLoading} className="close-btn" onClick={onCancel} appearance="secondary">{i18n.getString(_TL_('Close'))}</Button>
        </div>
        }

        {showBudgetSuggestion &&
        <div className={styles.containerLeft}>
          <Button disabled={isLoading} className={classNames('save-btn', styles.saveButton)} onClick={onSave} appearance="primary">{i18n.getString(_TL_('Apply'))}</Button>
          <Button disabled={isLoading} className="close-btn" onClick={onCancel} appearance="secondary">{i18n.getString(_TL_('Cancel'))}</Button>
        </div> }
      </>
    );
  };
  HoC.defaultProps = {
    headerState: undefined,
  };
  return HoC;
}
